export default [
    {
        path: '/prerequisite/vehicle-types',

        name: 'Vehicle Types',

        component: () => import('@/views/prerequisite/vehicle-types'),
    },
];